export default "__VITE_ASSET__rioxnI1S__"